import NotFoundPage from '@/components/NotFoundPage'
import PageLoading from '@/components/PageLoading'
import { routeTree } from '@/routeTree.gen'

import ErrorBoundary from '@/components/ErrorBoundary'
import { AnyRouteMatch, createRouter } from '@tanstack/react-router'
import { last } from 'lodash-es'
import queryClient from './queryClient'
import { isInternalLink } from './url'

declare module '@tanstack/react-router' {
	interface Register {
		// This infers the type of our router and registers it across your entire project
		router: typeof router
	}
}

const router = createRouter({
	routeTree,
	context: {
		queryClient,
	},
	defaultPreload: false,
	defaultNotFoundComponent: NotFoundPage,
	defaultPendingComponent: PageLoading,
	defaultErrorComponent: ErrorBoundary,
	defaultViewTransition: true,
})

export default router

/**
 * @param url
 * @returns
 */
export function getRouteMatch(url: string): AnyRouteMatch | null {
	const urlObject = new URL(url)
	if (!isInternalLink(url) || urlObject.pathname === '/') {
		return null
	}

	const matches = router.matchRoutes(
		urlObject.pathname,
		Object.fromEntries(urlObject.searchParams),
		{
			throwOnError: false,
		}
	)

	return last(matches) ?? null
}
